import { Button, Dialog, DialogContent, Stack, Typography } from '@mui/material';
import { withClarityTheme } from '@verifime/styles';
import ReportRequestedIllustration from './report-requested-illustration.svg';

export type ReportRequestedModalProps = {
  isOpen: boolean;
  onClose: () => void;
  customerName: string;
};

const ReportRequestedModalComponent = ({
  isOpen,
  onClose,
  customerName,
}: Readonly<ReportRequestedModalProps>) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          // Figma-specified modal width, shared with the Xpm confirmation modals
          // (XpmIntegrationSuccessModal etc). There is no standard dialog-width
          // token to use: this falls between size.xs and size.sm on the semantic
          // size scale. A dedicated token is tracked as TD-018.
          maxWidth: '500px',
          width: '100%',
        },
      }}
      data-testid="report-requested-modal"
    >
      <DialogContent
        sx={(theme) => ({
          px: theme.semantic.spacing['2lg'],
          py: theme.semantic.spacing.base,
        })}
      >
        <Stack
          alignItems="center"
          sx={(theme) => ({
            gap: theme.semantic.spacing['2lg'],
          })}
        >
          {/* Illustration */}
          <ReportRequestedIllustration />

          {/* Content Wrapper */}
          <Stack
            alignItems="center"
            sx={(theme) => ({
              gap: theme.semantic.spacing.sm,
              width: '100%',
            })}
          >
            <Typography variant="h4" textAlign="center">
              Report Requested for {customerName}
            </Typography>

            <Typography variant="body1" textAlign="center">
              Report detailing verification for {customerName} has been
              submitted. Once it is ready, usually within 10 minutes, we will
              email you a secure link to download the report from the portal.
            </Typography>
          </Stack>

          {/* Close Button */}
          <Button
            variant="outlined"
            onClick={onClose}
            fullWidth
            data-action="close-report-requested-modal"
          >
            CLOSE
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export const ReportRequestedModal = withClarityTheme(
  ReportRequestedModalComponent,
);
